import { useEffect, useState } from 'react';

/** Pausa da digitação que conta como "terminou de escrever". */
export const ATRASO_PADRAO = 300;

/**
 * Adia o valor digitado até a pessoa parar de escrever.
 *
 * Sem isso, cada tecla de um SKU vira uma consulta à listagem de
 * movimentações — a mais cara do painel (RNF-006). O campo continua
 * respondendo na hora; só a pergunta ao middleware é que espera.
 */
export function useValorAdiado<T>(valor: T, atraso: number = ATRASO_PADRAO): T {
  const [adiado, definirAdiado] = useState(valor);

  useEffect(() => {
    const temporizador = setTimeout(() => {
      definirAdiado(valor);
    }, atraso);

    return () => {
      clearTimeout(temporizador);
    };
  }, [valor, atraso]);

  return adiado;
}
